import { render, staticRenderFns } from "./aboutforapp.vue?vue&type=template&id=33cd2a76&scoped=true&"
import script from "./aboutforapp.vue?vue&type=script&lang=js&"
export * from "./aboutforapp.vue?vue&type=script&lang=js&"
import style0 from "./aboutforapp.vue?vue&type=style&index=0&id=33cd2a76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cd2a76",
  null
  
)

export default component.exports